import HttpRequest from './http_request'
import { getStoreBearer, getWerehouse } from '@/utils/helper/localStorage'

class ProductProvider extends HttpRequest {
  constructor () {
    super(process.env.SELLSUKI_URL)
  }
  async getProduct (searchKey, page = 1) {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const { data } = await this.get('/product', {
      is_dm: false,
      page: page,
      search: searchKey,
      warehouse: getWerehouse()
    })
    let results = {
      products: [],
      productsNumber: 0
    }
    if (data.results.length) {
      results.products = await this.tranfromData(data)
      results.productsNumber = data.results.length
    }
    return results
  }

  tranfromData (data) {
    let result = []
    try {
      data.results.forEach(items => {
        let count = 0
        let options = items.concat_sku_options.split(':;:')
        const images = items.concat_sku_src.split(':;:')
        const prices = items.concat_sku_price.split(':;:')
        const remain = items.concat_lot_remaining.split(':;:')
        const id = items.concat_sku_id.split(':;:')
        const code = items.concat_sku_code.split(':;:')
        const productId = items.id
        const name = items.name
        const tags = items.product_tags === null || !items.product_tags ? [] : items.product_tags.split(':;:')
        const categories = items.concat_product_category === null || !items.concat_product_category ? [] : items.concat_product_category.split(':;:')
        items.concat_sku_code.split(':;:').forEach(item => {
          let opt = options[count].split(',')
          result.push({
            productId: productId,
            id: id[count],
            code: code[count],
            name: name,
            tags,
            categories,
            amount: 1,
            option: options[count].replace(/,/g, ' '),
            option1: opt[0],
            option2: opt[1],
            variant1: items.variant_1,
            variant2: items.variant_2,
            optionPOSCompleteCart: options[count].replace(/,,/g, '').replace(/,$/g, ''),
            fullPrice: prices[count],
            price: prices[count],
            image: images[count],
            remain: remain[count],
            quantity: 1
          })
          count++
        })
      })
    } catch (error) {
      console.log(error)
    }
    return result
  }
}

export default ProductProvider



// WEBPACK FOOTER //
// ./src/resources/product_provider.js